module.exports = __webpack_public_path__ + "static/media/Follower_Button-21.3b32aa4e.png";